<template>
  <div class="common-form" :class="type === 'dark' ? 'dark' : 'light'">
<!--    <product-select @select="handleSelectProduct" v-if="showProductSelect"></product-select>-->
    <van-field placeholder="请填写姓名" label="姓名" required v-model="form.realName"></van-field>
    <van-field placeholder="请填写手机号码" label="手机号码" required v-model="form.mobile" @focus="hideError">
      <template slot="right-icon">
        <span class="error-message" v-show="phoneFormatError">格式错误</span>
      </template>
    </van-field>
    <van-field placeholder="请填写邮箱" label="邮箱" v-model="form.email"/>
    <van-field placeholder="请填写公司信息" label="公司名称" required v-model="form.companyName"></van-field>
    <area-select placeholder="请选择公司所在地区" label="所在地区" required @select="handleSelectArea"></area-select>
    <van-field placeholder="请填写公司详细地址" label="详细地址" v-model="form.companyAddress"></van-field>
    <submit-button @click="submitForm" :disabled="buttonDisbled" :loading="submitLoading"></submit-button>
  </div>
</template>

<script>
import FormMixins from '@mixins/form-mixins';
export default {
  name: 'CommonForm',
  mixins: [FormMixins],
  props: {
    type: { // 有两种值，dark和light，dark则表单的文字是黑灰色，light则表单的文字是白色
      type: String,
      default: 'light'
    },
    showProductSelect: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style lang="scss" scoped>
@import './CommonForm.scss';
</style>
